import { apiClient } from "@/lib/api-client";
import type { SlackTriggerAvailabilityResp, SlackTriggerChannelsResp } from "@/types/routines.ts";
import { queryOptions } from "@tanstack/react-query";

/**
 * The Slack trigger's queries, for web and native alike. Keyed under the
 * routines root so a routine write that invalidates every routine query
 * refreshes these too.
 */
export const slackTriggerQueryKey = ["routines", "slack-trigger"] as const;

/** Whether the routine form offers the Slack trigger, and in what state. */
export const slackTriggerAvailabilityQueryOptions = () =>
  queryOptions({
    queryKey: [...slackTriggerQueryKey, "availability"] as const,
    queryFn: ({ signal }) =>
      apiClient
        .get<SlackTriggerAvailabilityResp>("/api/a/routines/slack-trigger/availability", {
          signal,
        })
        .then((res) => res.data),
  });

/**
 * The channels a Slack trigger can watch. Only asked for once availability is
 * `ready` — the server refuses the list before then.
 */
export const slackTriggerChannelsQueryOptions = (enabled: boolean) =>
  queryOptions({
    queryKey: [...slackTriggerQueryKey, "channels"] as const,
    queryFn: ({ signal }) =>
      apiClient
        .get<SlackTriggerChannelsResp>("/api/a/routines/slack-trigger/channels", { signal })
        .then((res) => res.data),
    enabled,
  });
